import type { MessageTree, TranslateVars } from "./types";

const INTERPOLATION_PATTERN = /\{(\w+)\}/g;

/** Read a dot-path leaf out of a nested catalog. Returns `null` when missing or not a leaf. */
export function lookupMessage(catalog: MessageTree, key: string): string | null {
  let node: string | MessageTree | undefined = catalog;
  for (const segment of key.split(".")) {
    if (typeof node !== "object" || node === null) return null;
    node = (node as MessageTree)[segment];
  }
  return typeof node === "string" ? node : null;
}

/** Replace `{var}` placeholders. Unknown placeholders stay literal so gaps stay visible. */
export function interpolate(template: string, vars?: TranslateVars): string {
  if (!vars) return template;
  return template.replace(INTERPOLATION_PATTERN, (match, name: string) => {
    const value = vars[name];
    return value === undefined || value === null ? match : String(value);
  });
}

/** Collect `{var}` names used by a template, for catalog parity checks. */
export function interpolationVars(template: string): string[] {
  return Array.from(template.matchAll(INTERPOLATION_PATTERN), (match) => match[1]);
}

/**
 * Resolve one message. Missing keys fall back to the key itself so a gap shows up
 * on screen instead of rendering an empty node.
 */
export function translate(catalog: MessageTree, key: string, vars?: TranslateVars): string {
  const template = lookupMessage(catalog, key);
  if (template === null) return key;
  return interpolate(template, vars);
}
